import { createFileRoute } from "@tanstack/react-router";
import CompanySettingsForm from "@/components/Settings/CompanySettings";

function SettingsIndex() {
  return <CompanySettingsForm />;
}

export const Route = createFileRoute("/_auth/innstillinger/")({
  component: SettingsIndex,
  beforeLoad: () => ({
    getTitle: () => "Brukerinnstillinger",
  }),
});
